<template>
  <div id="app">
    <vheader></vheader>
    <keep-alive>
      <router-view  v-if="$route.meta.keepAlive" >
        <!-- 这里是会被缓存的视图组件 -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" >
      <!-- 这里是不被缓存的视图组件-->
    </router-view>
    <vfooter v-show="!$route.meta.publicShow"></vfooter>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'

  export default {
    name: 'App',
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return{
        isRouterAlive:true,
        isRouterAlive:true,
        header_show:true,
        footer_show:true,
      }
    },
    components: {
      'vheader':Header,
      'vfooter':Footer
    },
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        });
      },
      //是否显示头部
      public_header:function (bool) {
        this.header_show = bool;
      },
      //是否显示底部
      public_footer:function (bool) {
        this.footer_show = bool;
      }
    },

  }
</script>

<style>
  .img-vuer{
    /*transform: perspective(500px) matrix3d(1.5, 0, 0, 0, 0, 1.5, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)!important;*/
  }
  .img-vuer img{
    width: 90%;
    height: auto;
    left: .4rem!important;
    top: 2rem!important;
  }
  html {
    color: #333;
  }

  * {
    padding: 0;
    margin: 0;
  }

  * {
    box-sizing: border-box;
    max-height: 100000px;
  }

  *:before, *:after {
    box-sizing: border-box;
    max-height: 100000px;
  }
  * {
    -webkit-tap-highlight-color:transparent;
  }
  ul, ol, li {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: #666;
  }

  .router-link-active {
    text-decoration: none;
  }

  body {
    background: #f3f3f3;
  }

  img{
    vertical-align: bottom;
  }
  div.v-pagination>ul>li>a{
    font-size: .22rem!important;
    padding: .15rem .15rem!important;
    width: .8rem!important;
    white-space: nowrap;
  }
  div.v-pagination.v-pagination--center{
    margin-top: .18rem;
  }
  .social-share,.social-share-icon{
    width: 1rem!important;
    height: .6rem!important;
    font-size: .46rem!important;
    line-height: .52rem!important;
    display: flex!important;

  }
  .news-nr p{
    display: flex;
    flex-direction: column;
    justify-content: center;
    /*text-indent: 2em!important;*/
    margin-top: .1rem;
    /*width: 100%;*/

  }
  .news-nr img{
    width: 100%;
    height: auto;
  }
  .news-nr p img{
    width: 100%!important;
    height: auto;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue